export default __webpack_public_path__ + "locales/sr-Cyrl-RS/SendInviteDialog.json?hash=b4a6c0ca344ae9394ecbb00ca4f9c976";